import React from 'react'
import { xApp } from 'xumm-xapp-sdk'

interface XummLinkProps {
  href: string
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

/**
 * Link component that uses sdk.openBrowser() in xApp context
 * Falls back to normal link in browser
 * 
 * Required for Xaman xApp compliance - external links must use sdk.openBrowser()
 */
export const XummLink: React.FC<XummLinkProps> = ({ 
  href, 
  children, 
  style,
  className 
}) => {
  const [sdk, setSdk] = React.useState<xApp | null>(null)
  const [isXapp, setIsXapp] = React.useState(false)

  React.useEffect(() => {
    try {
      const instance = new xApp()
      setSdk(instance)
      const env = instance.getEnvironment()
      setIsXapp(!!env.ott)
    } catch {
      setIsXapp(false)
    }
  }, [])

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    
    if (isXapp && sdk) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (sdk as any).openBrowser({ url: href })
      } catch (error) {
        console.error('[XummLink] Error opening browser:', error)
        // Fallback to window.open
        window.open(href, '_blank', 'noopener,noreferrer')
      }
    } else {
      window.open(href, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <button 
      onClick={handleClick} 
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        textAlign: 'inherit',
        font: 'inherit',
        color: 'inherit',
        ...style
      }}
      className={className}
    >
      {children}
    </button>
  )
}
